import type { Lookup, PriceChangeFilterLookupItem } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

export const mapPriceChangeLookupItemsToOptions = (
  items?: Lookup[] | PriceChangeFilterLookupItem[]
): Option<string>[] =>
  (items ?? []).map(({ label, id }) => ({
    label,
    value: id,
  }))
